import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import * as moment from 'moment';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Profession } from 'src/app/utils/interfaces/new/profession.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-histo-profession',
  templateUrl: './histo-profession.fragment.html',
  styleUrls: [
    './histo-profession.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class HistoProfessionFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeHistoProfessionModal(false);
    }
  }

  @Output() public closeEmitter = new EventEmitter();

  public idPatient: string;
  public isEdit = false;
  public listProfession: Paginated<Profession>;
  public professionColumnTable = [];
  public deletedProfessions: Profession[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.listProfession) {
      for (let pro of this.listProfession.objects) {
        if (pro.disabled) {
          this.deletedProfessions.push(pro);
        }
      }
      for (let delPro of this.deletedProfessions) {
        const deleteIndex = this.listProfession.objects.findIndex(x => x.id === delPro.id);
        if (deleteIndex > -1) {
          this.listProfession.objects.splice(deleteIndex, 1);
        }
      }
      if (!this.isEdit) {
        for (let profession of this.listProfession.objects) {
          const startDate = profession.dateDebut;
          const endDate = profession.dateFin ? moment(profession.dateFin).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
          Object.defineProperty(profession, 'nbAnnees', { value: moment(endDate).diff(startDate, 'years').toString() });
        }
      }
    }
    if (this.isEdit) {
      this.professionColumnTable = [
        { title: 'Profession', data: 'nomProfession', isEditable: true, editType: 'string', validators: [Validators.required] },
        { title: 'Date de début', data: 'dateDebut', isEditable: true, editType: 'date', validators: [Validators.required] },
        { title: 'Date de fin', data: 'dateFin', isEditable: true, editType: 'date' },
        { title: 'Supprimer', data: null }
      ];
    } else {
      this.professionColumnTable = [
        { title: 'Profession', data: 'nomProfession' },
        { title: 'Nombre d\'année(s)', data: 'nbAnnees' },
        { title: 'Date de début', data: 'dateDebut' },
        { title: 'Date de fin', data: 'dateFin' },
      ];
    }
  }

  deleteProfession(event: any) {
    const deleteProIndex = this.listProfession.objects.findIndex(x => x.id === event.id);
    if (deleteProIndex > -1) {
      this.listProfession.objects[deleteProIndex].disabled = true;
      this.deletedProfessions.push(this.listProfession.objects[deleteProIndex]);
      this.listProfession.objects.splice(deleteProIndex, 1);
    }
  }

  changeProfessions(event: any) {
    for (let profession of event) {
      const index = this.listProfession.objects.findIndex(x => x.id === profession.id);
      if (index > -1) {
        this.listProfession.objects[index] = {
          nomProfession: profession.nomProfession,
          dateDebut: moment(profession.dateDebut).format("YYYY-MM-DD"),
          dateFin: moment(profession.dateFin).isValid() && profession.dateFin ? moment(profession.dateFin).format("YYYY-MM-DD") : undefined,
          idPatient: this.idPatient,
          id: profession.id
        }
      } else {
        this.listProfession.objects.push({
          idPatient: this.idPatient,
          nomProfession: profession.nomProfession,
          dateDebut: moment(profession.dateDebut).format("YYYY-MM-DD"),
          dateFin: moment(profession.dateFin).isValid() && profession.dateFin ? moment(profession.dateFin).format("YYYY-MM-DD") : undefined
        })
      }
    }
    this.listProfession.objects.sort((a: Profession, b: Profession) => {
      return (moment(a.dateDebut).format("YYYY-MM-DD") < moment(b.dateDebut).format("YYYY-MM-DD")) ? 1 : -1;
    });
    this.closeHistoProfessionModal(true);
  }

  closeHistoProfessionModal(send: boolean) {
    if (send) {
      for (let pro of this.deletedProfessions) {
        this.listProfession.objects.push(pro);
      }
      this.closeEmitter.emit(this.listProfession.objects);
    } else {
      if (this.isEdit) {
        for (let pro of this.deletedProfessions) {
          pro.disabled = false;
          this.listProfession.objects.push(pro);
        }
        this.listProfession.objects.sort((a: Profession, b: Profession) => {
          return (moment(a.dateDebut).format("YYYY-MM-DD") < moment(b.dateDebut).format("YYYY-MM-DD")) ? 1 : -1;
        });
      }
      this.closeEmitter.emit();
    }

  }

}
